import { createRoot } from "react-dom/client";

const DEFAULT_DESTRUCTION_DELAY = 300;
const DEFAULT_OPTIONS = {
    destructionDelay: DEFAULT_DESTRUCTION_DELAY,
};

const noop = () => { };

export default function reactModal(renderModal, options = {}) {
    const { destructionDelay } = { ...DEFAULT_OPTIONS, ...options };
    const container = document.createElement('div');
    const parentToModal = document.body;
    parentToModal.appendChild(container);
    const root = createRoot(container);

    if(  options.keyHandler != null)
    {
        window.addEventListener("keydown", options.keyHandler);
    }

    function displayModal({ onSubmit, onDismiss }) {
        if( options.getCloseCallback != null && typeof options.getCloseCallback === "function" )
        {
            options.getCloseCallback(onSubmit);
        }

        root.render(renderModal({ onSubmit, onDismiss, show: true }));
    }

    function hideModal({ onSubmit, onDismiss }, callback) {
        // TODO: This is not using the callback atm.
        // old code: render(renderModal({ onSubmit, onDismiss, show: false }), container, callback);
        root.render(renderModal({ onSubmit, onDismiss, show: false }));
    }

    function destroyModal() {
        root.unmount();
        parentToModal.removeChild(container);
    }

    const confirmation = new Promise((resolve) => {
        const onSubmit = (value = true) => {
            resolve(value);
        }
        const onDismiss = () => {
            resolve(undefined);
        }
        displayModal({ onSubmit, onDismiss });
    });

    return confirmation["finally"](() => {
        const onSubmit = noop;
        const onDismiss = noop;

        hideModal({ onSubmit, onDismiss }, () => {
            if(  options.keyHandler != null)
            {
                window.removeEventListener("keydown", options.keyHandler);
            }

            setTimeout(destroyModal, destructionDelay);
        });
    });
}